import { PayloadAction } from '../../../../store.model';
import { groups } from '../const/view-groups.const';
import { filterIsDefault } from '../function/filter-is-default.function';
import { filterItems } from '../function/filter-items.function';
import { groupItems } from '../function/group-items.function';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';
import { viewTaskItemTransformer } from '../transformer/view-task-item.transformer';

import { FilterItems } from './filter-items.action';

export function filterItemsReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, FilterItems>,
): TaskListDialogState {
    try {
        const nextViewItems = viewTaskItemTransformer(state.tasks);

        const nextFilt = filterItems({
            items: nextViewItems,
            filterOpts: action.payload.opts,
            orderBy: state.orderBy,
        });

        const nextFiltDef = filterIsDefault(action.payload.opts);

        const nextGroups = groupItems(groups, nextFilt);

        return {
            ...state,
            filterOpts: action.payload.opts,
            filterIsDefault: nextFiltDef,
            groups: nextGroups,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
